import { ApplicationInsights } from "@microsoft/applicationinsights-web";

export const appInsights = new ApplicationInsights({
    config: {
        connectionString:
            "InstrumentationKey=00000000-0000-0000-0000-000000000000;IngestionEndpoint=//aai.agoda.net;LiveEndpoint=//aai.agoda.net;ProfilerEndpoint=//aai.agoda.net;SnapshotEndpoint=//aai.agoda.net;",
        autoTrackPageVisitTime: true,
        disableFetchTracking: false,
        enableAjaxErrorStatusText: true,
        enableAjaxPerfTracking: true,
        enableAutoRouteTracking: true,
    },
});

let initialized = false;

export const addAppInsights = async (): Promise<void> => {
    if (!initialized) {
        appInsights.loadAppInsights();
        appInsights.addTelemetryInitializer((envelope) => {
            envelope.tags!["ai.cloud.role"] = "property-onboarding-clientside";
        });
        appInsights.trackPageView();

        initialized = true;
    }
};
